import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/PassDowns/hooks/usePassDown.ts
/**
* Get a single PassDown data
* @param args
* @param opts
*/
function usePassDown(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.PassDowns.GetPassDown.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.passDownId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { usePassDown };

//# sourceMappingURL=usePassDown.js.map